import React from 'react'
// import Resume from '../../assets/KEVINBLANCO_RESUME.pdf'

export default function CallToAction() {
  return (
    <div className='CallToAction'>
      <a href='https://drive.google.com/file/d/1Y7Bua3x-tEAenMdqZESJbyPddmwT-d99/view?usp=sharing' target='_blank' className='btn'>View Resume</a>
      <a href='#contact' className='btn btn-primary'>Let's Chat</a>
    </div>
  )
}

